import React from 'react';

import { emptyFunction } from '../utilities';

const Input = ({
  type, name, placeholder, onChange, onKeyUp, className, autoFocus, required, value, checked, style
}) => (
  <input
    type={type}
    name={name}
    placeholder={placeholder}
    onChange={onChange}
    onKeyUp={onKeyUp}
    className={`a-input lh-title fw3 w-90 ${className}`}
    autoFocus={autoFocus}
    required={required}
    checked={checked}
    value={value}
    style={style}
  />
);

Input.defaultProps = {
  type: 'text',
  name: 'field',
  placeholder: 'EN placeholder',
  onChange: emptyFunction,
  onKeyUp: emptyFunction,
  className: '',
  autoFocus: false,
  required: false,
  style: {}
};

export default Input;
